module.exports = __webpack_public_path__ + "img/admin-logo-new@2x.173dd774.png";